<template>
  <v-container id="userAboutBasic" class="pa-0 pb-5">
    <v-progress-linear class="ma-0" v-if="isAllLoading" indeterminate color="blue"></v-progress-linear>
    <v-form v-show="!isAllLoading" ref="form" v-model="form.valid">
      <v-list class="pt-4">
        <UserAboutBasicName class="abt-item px-3" ref="name"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicSex class="abt-item px-3" ref="sex"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicBirthday class="abt-item px-3" ref="birthday"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicMarry class="abt-item px-3" ref="marry"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicNationality class="abt-item px-3" ref="nationality"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicBirthplace class="abt-item px-3" ref="birthplace"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <UserAboutBasicNotes class="abt-item px-3" ref="notes"
          :status="getStatus"
          :data="getData"
          @emit="emitted"
        />
        <v-divider class="abt-item px-3"></v-divider>
        <v-subheader class="abt-item px-3">住まい</v-subheader>
        <UserAboutBasicHome v-for="item in getAddressItems" class="abt-item px-3" ref="address"
          :key="item.id"
          :status="getStatus"
          :data="item"
          @emit="emitted"
        />
        <UserAboutBasicHomeInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted" />
        <v-divider class="abt-item px-3"></v-divider>
        <v-subheader class="abt-item px-3">連絡先</v-subheader>
        <UserAboutBasicContact v-for="item in getContactItems" class="abt-item px-3" ref="contact"
          :key="item.id"
          :status="getStatus"
          :data="item"
          @emit="emitted"
        />
        <UserAboutBasicContactInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted" />
      </v-list>
    </v-form>
  </v-container>
</template>

<script>
import UserAboutBasicName from './components/name'
import UserAboutBasicSex from './components/sex'
import UserAboutBasicBirthday from './components/birthday'
import UserAboutBasicMarry from './components/marry'
import UserAboutBasicBirthplace from './components/birthplace'
import UserAboutBasicNationality from './components/nationality'
import UserAboutBasicNotes from './components/notes'
import UserAboutBasicHome from './components/home'
import UserAboutBasicHomeInsert from './components/home/modals/insert'
import UserAboutBasicContact from './components/contact'
import UserAboutBasicContactInsert from './components/contact/modals/insert'

const DEFAULT = {
  STATUS: {
    LOADING: 'all',
    EDITING: '',
    SUBMITTING: ''
  },
  FORM: {
    ITEM: {
      DEFAULT: JSON.stringify({
        value: '',
        required: false
      }),
      REQUIRED: JSON.stringify({
        value: '',
        required: true
      })
    }
  }
}
export default {
  name: 'userAboutBasic',
  components: {
    UserAboutBasicName,
    UserAboutBasicSex,
    UserAboutBasicMarry,
    UserAboutBasicBirthday,
    UserAboutBasicBirthplace,
    UserAboutBasicNationality,
    UserAboutBasicNotes,
    UserAboutBasicHome,
    UserAboutBasicHomeInsert,
    UserAboutBasicContact,
    UserAboutBasicContactInsert
  },
  props: [
    'embeded'
  ],
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          editing: DEFAULT.STATUS.EDITING
        }
      },
      form: {
        valid: true
      },
      store: {
      }
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$nextTick(() => {
        this.get()
      })
    },
    get: function (type) {
      this.$set(this.config.status, 'loading', type != null ? type : 'all')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: true
        }
      })
      this.axios.post(`${this.$url.api}user/about/get/basic`, {}, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        this.$set(this.config.status, 'loading', '')
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: false
          }
        })
        if (res.data && res.data.success) {
          this.$set(this, 'store', res.data.data)
          this.$emit('update', { type: 'basic' })
        }
      })
    },
    prepare: function () {
      this.$refs.name.prepare()
      this.$refs.sex.prepare()
      this.$refs.birthday.prepare()
      this.$refs.marry.prepare()
      this.$refs.nationality.prepare()
      this.$refs.birthplace.prepare()
      this.$refs.notes.prepare()
      if (this.$refs.address) {
        for (let i = 0; i < this.$refs.address.length; i++) {
          this.$refs.address[i].prepare()
        }
      }
      if (this.$refs.contact) {
        for (let i = 0; i < this.$refs.contact.length; i++) {
          this.$refs.contact[i].prepare()
        }
      }
      this.edit()
    },
    edit: function (req) {
      const { id, type } = req || {}
      if (id) {
        this.$set(this.config.status, 'editing', id)
      } else if (type) {
        this.$set(this.config.status, 'editing', type)
      } else {
        this.$set(this.config.status, 'editing', 'all')
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: true
        }
      })
    },
    insert: function (req) {
      if (req && req.id) {
        if (req.id.indexOf('addr_') >= 0 && this.store.addresses) {
          this.store.addresses.push(req)
          this.$nextTick(() => {
            this.$refs.address[this.$refs.address.length - 1].prepare()
          })
        } else if (req.id.indexOf('cont_') >= 0 && this.store.contacts) {
          this.store.contacts.push(req)
          this.$nextTick(() => {
            this.$refs.contact[this.$refs.contact.length - 1].prepare()
          })
        }
      }
    },
    remove: function (req) {
      if (req && req.id) {
        if (req.id.indexOf('addr_') >= 0 && this.store.addresses) {
          let idx = this.store.addresses.findIndex(it => {
            return it.id === req.id
          })
          if (idx >= 0) {
            this.store.addresses.splice(idx, 1)
          }
        } else if (req.id.indexOf('cont_') >= 0 && this.store.contacts) {
          let idx = this.store.contacts.findIndex(it => {
            return it.id === req.id
          })
          if (idx >= 0) {
            this.store.contacts.splice(idx, 1)
          }
        }
      }
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          addresses: [],
          contacts: []
        }
        if (['name', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.name.getForm())
        }
        if (['sex', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.sex.getForm())
        }
        if (['birthday', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.birthday.getForm())
        }
        if (['marry', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.marry.getForm())
        }
        if (['nationality', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.nationality.getForm())
        }
        if (['birthplace', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.birthplace.getForm())
        }
        if (['notes', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.notes.getForm())
        }
        if (this.config.status.editing === 'all') {
          for (let i = 0; i < this.$refs.address.length; i++) {
            fd.addresses.push(this.$refs.address[i].getForm())
          }
          for (let i = 0; i < this.$refs.contact.length; i++) {
            fd.contacts.push(this.$refs.contact[i].getForm())
          }
        }
        if (this.config.status.editing.indexOf('addr_') >= 0) {
          let idx = this.$refs.address.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.addresses.push(this.$refs.address[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('cont_') >= 0) {
          let idx = this.$refs.contact.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.contacts.push(this.$refs.contact[idx].getForm())
          }
        }
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: true
          }
        })
        this.axios.post(`${this.$url.api}user/about/update/basic`, fd, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'editing', '')
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'loading',
              status: false
            }
          })
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'editing',
              status: false
            }
          })
          if (res.data && res.data.success) {
            this.get(this.config.status.editing)
            if (fd.name && fd.name.length) {
              this.$store.commit('user/update', {
                name: fd.name
              })
            }
            if (fd.kana && fd.kana.length) {
              this.$store.commit('user/update', {
                kana: fd.kana
              })
            }
          }
        })
      }
    },
    close: function () {
      this.$set(this.form, 'valid', true)
      this.$set(this.config.status, 'editing', '')
    },
    getStore: function () {
      return this.store
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isEmbeded () {
      return !!(
        this.$props.embeded != null && this.$props.embeded !== false
      )
    },
    isValid () {
      return this.form.valid
    },
    isEditing () {
      return this.config.status.editing
    },
    isAllEditing () {
      return this.config.status.editing === 'all'
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isAllLoading () {
      return this.config.status.loading === 'all'
    },
    getStatus () {
      return this.config.status
    },
    getData () {
      return this.store
    },
    getAddressItems () {
      return (
        this.store.addresses
      ) ? this.store.addresses : []
    },
    getContactItems () {
      return (
        this.store.contacts
      ) ? this.store.contacts : []
    }
  }
}
</script>
